module.exports = __webpack_public_path__ + "static/media/mdif-investor-logo.255942b4.jpeg";